import { useState, useEffect } from 'react'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select'
import { checkboxData } from './checkboxData';
import './style.css'
import { useUserAuth } from '../../context/UserAuthContext';
import { useFormik } from 'formik';
import { corporateTtkSchema } from '../schemas';
import axios from "axios";
import { NumericFormat } from 'react-number-format';
import ThinksToKnowStatus from './ThinksToKnowStatus';

const CorporateTTK = () => {
    const [ttkEditMode, setTtkEditMode] = useState(false)
    const { user, language, token, currency } = useUserAuth();
    const merchant_id = user.uid;
    const [merchant, setMerchant] = useState({});
    const base_url = import.meta.env.VITE_LOCAL_BASE_URL;
    const getSingleDocumentHandler = async () => {
        try {
            const res = await axios.get(
                `${base_url}/api/v1/thinkstoknow/${merchant_id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
            );
            const data = res.data.data;
            const details = data[0].details;
            // const details = rawDetails ? JSON.parse(rawDetails) : null;
            if (details) {
                setMerchant(details);
                // formik.setValues(details);
            }
        } catch (error) {
            console.log(`Error : ${error}`);
        }
    };

    useEffect(() => {
        if (!merchant_id) return
        getSingleDocumentHandler()
    }, [merchant_id, token])
    const workingSinceOption = checkboxData.workSinceOption;
    const areaOfWorkingOption = checkboxData.areaOfWorking;
    const planningTypeOption = checkboxData.planningTypeCop;

    const formik = useFormik({
        initialValues: {
            budget: Math.floor(merchant?.budget * currency.value) || '',
            CoverdofEvents: merchant?.CoverdofEvents || '',
            Fees: merchant?.Fees || '',
            workingSince: merchant?.workingSince || [],
            planningType: merchant?.planningType || [],
            areaOfWork: merchant?.areaOfWork || [],
        },
        enableReinitialize: true,
        validationSchema: corporateTtkSchema,
        onSubmit: async (values) => {
            try {
                const data = {
                    id: merchant_id,
                    details: { ...values, budget: Math.floor(values.budget * currency.country_value) },
                };

                const res = await axios.post(`${base_url}/api/v1/thinkstoknow`, data, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (res.status === 201) {
                    toast.success("Things to know added successfully.");
                    setMerchant(values);
                    formik.setValues(values);
                    setTtkEditMode(false);
                } else if (res.status === 202) {
                    toast.success("Your update is pending approval by the admin.");
                    setTtkEditMode(false);
                } else {
                    toast.info(res.data.message || "Request submitted.");
                    setTtkEditMode(false);
                }

            } catch (error) {
                console.error(`Error ${error}`);
                toast.error('An error occurred while submitting the data.');
            }
        },
    });

    return (
        <div className="page-wrapper">
            <div className="container-fluid">
                 <ThinksToKnowStatus/>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='card'>
                            <div className='card-header  text-white text-center ' style={{ backgroundColor: '#085f9a' }}>
                                <h5> {language === 'en' ? 'Things to Know' : 'जानने योग्य जानकारी भरे'}</h5>
                            </div>
                            <div className='card-body'>
                                {
                                    merchant && (
                                        <>
                                            <div className='table-responsive'>
                                                <table className='table text-center' cellPadding={0} cellSpacing={0} style={{ border: '1px solid #fff ' }}>
                                                    <tbody className='ttk_preview'>
                                                        <tr style={{ color: '#41B0FA' }}>
                                                            <th style={{ width: '25%' }}>Working Since</th>
                                                            <th style={{ width: '25%' }}>Planning Type</th>
                                                            <th style={{ width: '25%' }}>Area Of Services</th>
                                                            <th style={{ width: '25%' }}>Services Starts At</th>

                                                        </tr>
                                                        <tr>
                                                            <td>{
                                                                merchant.workingSince?.map((item, index) => {
                                                                    return <p key={index}>{item.value}</p>
                                                                })
                                                            }</td>
                                                            <td>
                                                                {
                                                                    merchant.planningType
                                                                        ?.map((item, index) => {
                                                                            return (<span key={index}>
                                                                                <i className='fa fa-check text-success' />
                                                                                <span >{item.value} </span>
                                                                            </span>)
                                                                        })
                                                                }
                                                            </td>
                                                            <td>{
                                                                merchant.areaOfWork
                                                                    ?.map((item, index) => {
                                                                        return (<span key={index}>
                                                                            <i className='fa fa-check text-success' />
                                                                            <span >{item.value} </span>
                                                                        </span>)
                                                                    })
                                                            }</td>
                                                            <td>  <NumericFormat
                                                                value={Math.floor(
                                                                    currency.value * merchant.budget
                                                                )}
                                                                displayType="text"
                                                                thousandsGroupStyle={
                                                                    currency.symbol === "₹" ? "lakh" : "thousand"
                                                                }
                                                                thousandSeparator=","
                                                                renderText={(formattedValue) => (
                                                                    <span>
                                                                        {currency.symbol}&nbsp;{formattedValue}
                                                                    </span>
                                                                )}
                                                            /></td>


                                                        </tr>
                                                        <tr style={{ color: '#41B0FA' }}>
                                                            <th>No. of Events Covered</th>
                                                            <th>Fees Structure</th>
                                                        </tr>
                                                        <tr>

                                                            <td> {merchant.CoverdofEvents}</td>
                                                            <td>{merchant.Fees}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>

                                            </div>
                                        </>
                                    )
                                }
                                <center >
                                    <button className='btn text-white mb-2' onClick={() => setTtkEditMode(!ttkEditMode)} style={{ backgroundColor: '#085f9a' }}>{`${merchant ? 'Make Changes' : 'Tell me more about yourself'}`}</button>
                                </center>
                                {
                                    ttkEditMode && (
                                        <form onSubmit={formik.handleSubmit}>
                                            <div className='row'>
                                                <div className='col-md-6'>

                                                    <div className='form-group'>
                                                        <label>Working Since <span className='text-danger'>*</span></label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={workingSinceOption}
                                                            selected
                                                            value={formik.values.workingSince}
                                                            onChange={(workingSince) => formik.setFieldValue('workingSince', workingSince)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.workingSince && formik.errors.workingSince ? (
                                                            <div className="text-danger">{formik.errors.workingSince}</div>
                                                        ) : null}
                                                    </div>

                                                </div>


                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Planning Type <span className='text-danger'>*</span></label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={planningTypeOption}
                                                            selected
                                                            value={formik.values.planningType}
                                                            onChange={(planningType) => formik.setFieldValue('planningType', planningType)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.planningType && formik.errors.planningType ? (
                                                            <div className="text-danger">{formik.errors.planningType}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Area of Services <span className='text-danger'>*</span></label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={areaOfWorkingOption}
                                                            selected
                                                            value={formik.values.areaOfWork}
                                                            onChange={(areaOfWork) => formik.setFieldValue('areaOfWork', areaOfWork)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.areaOfWork && formik.errors.areaOfWork ? (
                                                            <div className="text-danger">{formik.errors.areaOfWork}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <label class="" for="inlineFormInputGroup">Services Starts At</label>
                                                    <div class="input-group mb-2">
                                                        <div class="input-group-prepend">
                                                            <div class="input-group-text">{currency?.symbol}</div>
                                                        </div>
                                                        <input
                                                            type='number' placeholder='Services Starts At' className='form-control' name="budget" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.budget} />
                                                    </div>
                                                    {formik.touched.budget && formik.errors.budget ? (
                                                        <div className="text-danger">{formik.errors.budget}</div>
                                                    ) : null}
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>No of Events Covered <span className='text-danger'>*</span></label>
                                                        <input type='number' placeholder='Coverd of events' className='form-control' name="CoverdofEvents" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.CoverdofEvents} />
                                                        {formik.touched.CoverdofEvents && formik.errors.CoverdofEvents ? (
                                                            <div className="text-danger">{formik.errors.CoverdofEvents}</div>
                                                        ) : null}
                                                    </div>
                                                </div>

                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Fees Structure<span className='text-danger'>*</span></label>
                                                        {/* <input type='number' placeholder='Fees Structure' className='form-control' name="Fees" value={data.Fees} onChange={formHandler} /> */}
                                                        <select name="Fees" className="form-select" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.Fees}>
                                                            <option value="">Select </option>
                                                            <option value="Fixed Cost">Fixed Cost</option>
                                                            <option value="Commission Based">Commission Based</option>
                                                            <option value="As Per Event">As Per Event</option>
                                                            <option value="Nothing Fixed">Nothing Fixed</option>
                                                        </select>
                                                        {formik.touched.Fees && formik.errors.Fees ? (
                                                            <div className="text-danger">{formik.errors.Fees}</div>
                                                        ) : null}
                                                    </div>
                                                </div>




                                            </div>
                                            <div className='form-group'>
                                                <button className='btn text-white' type="submit" style={{ backgroundColor: '#085f9a' }}>Submit</button>
                                            </div>
                                        </form>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}
export default CorporateTTK